export function saveBlob(blob, name) {
    const url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download=name;link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
export function networkFilename(network,extension,comparison) {
    const safe=value=>String(value).replace(/[<>:"/\\|?*\u0000-\u001f]/g,'_').replace(/[ .]+$/g,'').slice(0,80);
    const names=[network?.cohort?.name || "Variant network",...(comparison?[comparison.cohort?.name || "Comparison network"]:[])];
    return ['RGNET',...names,network?.gene].filter(Boolean).map(safe).join('-')+'.'+extension;
}
export function chartSvg(instance) {
    const uri=instance.getDataURL({type:'svg',backgroundColor:'#f8fbfc'}),raw=uri.split(',').slice(1).join(',');
    return uri.includes(';base64,')?atob(raw):decodeURIComponent(raw);
}
export async function chartPng(instance) {
    const width=instance.getWidth(),height=instance.getHeight(),svg=chartSvg(instance),url=URL.createObjectURL(new Blob([svg],{type:'image/svg+xml;charset=utf-8'}));
    try {
        const image=new Image();await new Promise((resolve,reject)=>{
            const timer=setTimeout(()=>reject(new Error('PNG image conversion timed out')),10000);
            image.onload=()=>{clearTimeout(timer);resolve();};image.onerror=()=>{clearTimeout(timer);reject(new Error('PNG image conversion failed'));};image.src=url;
        });
        const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(width*2));canvas.height=Math.max(1,Math.round(height*2));
        const context=canvas.getContext('2d');if(!context)throw new Error('PNG canvas unavailable');context.fillStyle='#f8fbfc';context.fillRect(0,0,canvas.width,canvas.height);context.drawImage(image,0,0,canvas.width,canvas.height);
        return await new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('PNG encoding failed')),'image/png'));
    } finally {URL.revokeObjectURL(url);}
}
